import React, { useState, useEffect } from 'react';
import BottomBar from './BottomBar';
import './bottomBar.css';

const BottomBarContainer = ({ showUnifiedPanel = false, panelWidth = 'default' }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('BottomBarContainer: Expanding...', 'current expanded:', expanded);
    setExpanded(true);
  };

  const handleHide = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('BottomBarContainer: Hiding...', 'current expanded:', expanded);
    setExpanded(false);
  };

  return (
    <div 
      className={`bottom-bar-container ${expanded ? 'expanded' : 'collapsed'} ${showUnifiedPanel ? 'panel-open' : ''} ${showUnifiedPanel && panelWidth !== 'default' ? `panel-${panelWidth}` : ''}`}
    >
      {/* Render BottomBar */}
      <BottomBar 
        expanded={expanded} 
        onExpand={handleExpand} 
        onHide={handleHide} 
      />

      {/* Control Buttons - Always visible */}
      <div className="controllBtnsWrapper z-50*2">
        {/* Graph Icon */}
        <div className="graph-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M2 16H4V10H2V16ZM6 16H8V4H6V16ZM10 16H12V12H10V16ZM14 16H16V8H14V16Z" fill="#FFD700"/>
            <path d="M2 16L4 10L6 4L8 4L10 12L12 12L14 8L16 8" stroke="#FFD700" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          </svg>
        </div>
        {/* Toggle Button */}
        <a 
          href="#" 
          className="toggleBtn" 
          data-uk-tooltip={expanded ? "Hide Graphs" : "Show Graphs"} 
          onClick={expanded ? handleHide : handleExpand}
        >
          <span className="iconWrapper">
            {expanded ? (
              /* SVG for hide/close */
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M16.875 7.875H1.125C0.826631 7.875 0.540484 7.99353 0.329505 8.20451C0.118527 8.41548 0 8.70163 0 9C0 9.29837 0.118527 9.58452 0.329505 9.79549C0.540484 10.0065 0.826631 10.125 1.125 10.125H16.875C17.1734 10.125 17.4595 10.0065 17.6705 9.79549C17.8815 9.58452 18 9.29837 18 9C18 8.70163 17.8815 8.41548 17.6705 8.20451C17.4595 7.99353 17.1734 7.875 16.875 7.875Z" fill="#333333"/>
              </svg>
            ) : (
              /* SVG for expand */
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M16.875 7.875H10.125V1.125C10.125 0.826631 10.0065 0.540484 9.79549 0.329505C9.58452 0.118527 9.29837 0 9 0C8.70163 0 8.41548 0.118527 8.20451 0.329505C7.99353 0.540484 7.875 0.826631 7.875 1.125V7.875H1.125C0.826631 7.875 0.540484 7.99353 0.329505 8.20451C0.118527 8.41548 0 8.70163 0 9C0 9.29837 0.118527 9.58452 0.329505 9.79549C0.540484 10.0065 0.826631 10.125 1.125 10.125H7.875V16.875C7.875 17.1734 7.99353 17.4595 8.20451 17.6705C8.41548 17.8815 8.70163 18 9 18C9.29837 18 9.58452 17.8815 9.79549 17.6705C10.0065 17.4595 10.125 17.1734 10.125 16.875V10.125H16.875C17.1734 10.125 17.4595 10.0065 17.6705 9.79549C17.8815 9.58452 18 9.29837 18 9C18 8.70163 17.8815 8.41548 17.6705 8.20451C17.4595 7.99353 17.1734 7.875 16.875 7.875Z" fill="#333333"/>
              </svg>
            )}
          </span>
        </a>
      </div>
    </div>
  );
};

export default BottomBarContainer;

